import fetch from "libs/fetchWithAuth";
import { apiUrl } from 'libs/apiUrl';
const _baseUrl = apiUrl('/api/ext/concordance');

class Concordance {

	static search(data, req) {
		return fetch(_baseUrl + '/search', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static requestSynonym(data, req) {
		return fetch(_baseUrl + '/request-synonym', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static requestUnterm(data, req) {
		return fetch(_baseUrl + '/request-unterm', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}
}

export default Concordance;
